const sendAccountMergingStatusToAnalytics = (eventAction) => {
  window.app.analytics.publish('auto-tracking', 'forgerock', {
    'event_label': 'couple-screen',
    'event_action': eventAction,
    'event_name': 'forgerock',
    'event_category': 'auto-tracking',
  });
};

const sendForgotPasswordStepsToAnalytics = (eventAction) => {
  window.app.analytics.publish('auto-tracking', 'reset-password', {
    'event_label': 'couple-screen-reset-password',
    'event_action': eventAction,
    'event_name': 'reset-password',
    'event_category': 'auto-tracking',
  });
};

export { sendAccountMergingStatusToAnalytics, sendForgotPasswordStepsToAnalytics };
